var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3593 7.72967C5.41294 7.19974 5.21085 6.67597 4.81515 6.31931L0.784387 1.46361V0.738281H13.2999L22.9737 21.9542L31.4786 0.738281H43.4097V1.46361L39.9634 4.7679C39.6663 4.99438 39.5189 5.3666 39.5805 5.73501V30.0135C39.5189 30.3819 39.6663 30.7541 39.9634 30.9806L43.3291 34.2849V35.0102H26.3999V34.2849L29.8865 30.9C30.2291 30.5575 30.2291 30.4567 30.2291 29.9329V10.3086L20.5351 34.9296H19.2251L7.93899 10.3086V26.8099C7.84489 27.5037 8.0753 28.2022 8.56376 28.7038L13.0984 34.2043V34.9296H0.240234V34.2043L4.77484 28.7038C5.25974 28.2013 5.47672 27.4982 5.3593 26.8099V7.72967Z",
    fill: "#0476ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.8911f473af1db057a1f1ae520d963516.svg";
export { ForwardRef as ReactComponent };